export default __webpack_public_path__ + "static/media/ger.82bab208.svg";